"use client";
import { jsx } from "react/jsx-runtime";
import { cn } from "../../utils/cn.js";
import { ScrollArea } from "../ScrollArea/index.js";
function DrawerBody({ children, className, slots }) {
    return /*#__PURE__*/ jsx(ScrollArea, {
        drawerBody: true,
        className: cn('flex-1', className),
        slots: slots,
        children: children
    });
}
export { DrawerBody };
